/**
 * Khai báo locale — nguồn sự thật duy nhất. Thêm ngôn ngữ = thêm 1 phần tử ở đây rồi
 * để TypeScript chỉ ra mọi chỗ còn thiếu (Record<Locale, …> sẽ đỏ hết).
 */
export const LOCALES = ['vi', 'en'] as const;

export type Locale = (typeof LOCALES)[number];

/** Locale mặc định khi không suy ra được gì từ request (nginx redirect `/` về đây). */
export const DEFAULT_LOCALE: Locale = 'vi';

/**
 * `x-default` của hreflang: bản dành cho người dùng không khớp ngôn ngữ nào.
 * Theo quy ước phổ biến, đây là bản tiếng Anh.
 */
export const X_DEFAULT_LOCALE: Locale = 'en';

/** Giá trị cho thuộc tính `<html lang>` — phải là BCP-47 đầy đủ, không phải mã 2 chữ. */
export const HTML_LANG: Record<Locale, string> = {
  vi: 'vi-VN',
  en: 'en-US',
};

/** Giá trị cho `<meta property="og:locale">` — Open Graph dùng dấu gạch dưới. */
export const OG_LOCALE: Record<Locale, string> = {
  vi: 'vi_VN',
  en: 'en_US',
};

/** Nhãn hiển thị trên bộ chuyển ngôn ngữ (luôn viết bằng chính ngôn ngữ đó). */
export const LOCALE_LABEL: Record<Locale, string> = {
  vi: 'Tiếng Việt',
  en: 'English',
};

export function isLocale(value: string | undefined): value is Locale {
  return value !== undefined && (LOCALES as readonly string[]).includes(value);
}
